// extracted by mini-css-extract-plugin
module.exports = {"biomarkerStyle":"_1nawxxYi__HdnBHPRiSX0n","metricStyle":"_1eimwBhF1l96JGUKkI74zL"};